import React from 'react';
import { PureComponent } from 'react';
import { staticData } from './constants';
import './Loader.scss';
import PropTypes from 'prop-types';

class Loader extends PureComponent {
	constructor (props) {
		super(props);
		this.state = {
			showLoader: false,
			message: null,
			bodyStyle: ''
		};
	}

	componentDidMount = () => {
		this.timer = window.setTimeout(() => {
			this.setState({ showLoader: true });
			this.createLoaderMessage();
		}, staticData.loaderDelayTime);
	}

	createLoaderMessage = () => {
		let message = this.props.message || staticData.message;
		if (message.constructor === Array) {
			this.generateMessageQueue(message);
		} else {
			this.setState({ message: message });
		}
	}

	generateMessageQueue = (message) => {
		this.messageTimer = [];
		message.forEach((message, i) => {
			this.messageTimer[i] = window.setTimeout(() => {
				this.setState({ message: message });
			}, staticData.messageDelayTime * i);
		});
	}

	componentWillUnmount = () => {
		clearTimeout(this.timer);
		if (this.messageTimer && this.messageTimer.length > 0) {
			this.messageTimer.forEach((messageTimer) => {
				clearTimeout(messageTimer);
			});
		}
	}

	render() {
		const GenerateMessage = () => {
			return (
				<div className='message' style={{ animationDuration: staticData.messageDelayTime + 'ms' }}>
					{this.state.message}
					<i className='dot'>.</i>
					<i className='dot'>.</i>
					<i className='dot'>.</i>
				</div>
			);
		};

		return (
			<div className={'background'}>
				{this.state.showLoader && (
					<div className='loader'>
						<div className='loader-spinner'>
							<div className='loader-circle'>
								<div className='loader-innerCircle' />
							</div>
						</div>
						{this.props.hideMessage ? (
							''
						) : (
							<div className='loader-content'>
								<GenerateMessage />
							</div>
						)}
					</div>
				)}
			</div>
		);
	}
}

Loader.propTypes = {
	hideMessage: PropTypes.func,
	message: PropTypes.string
};

export default Loader;
